<mat-dialog-content style="position: relative;">
  <div *ngIf="config.ViewMode == 'page'" style="position: absolute; top: 0px; right: 0px;">
    <ng-content></ng-content>
  </div>
  <div style="display:flex;" [ngStyle]="{'justify-content': config.IsMobilePreview ? 'flex-start' : 'flex-end'}"
    *ngIf="config.AllowConditionalObjects && isPreview && (config.ViewMode == 'template' || config.ViewMode == 'instance' || config.ViewMode == 'page' || config.ViewMode == 'customPage' || config.ViewMode == 'frma')">
    <tyl-checkbox id='chkShowConditional' name='chkShowConditional' [(checked)]='showConditionalObjects'
      (change)="showConditionalChange()">Show conditional objects</tyl-checkbox>
    <tyl-form-field label='Language' style="padding-left:10px;" *ngIf="!config.IsMobilePreview && !config.HideLanguageDropDown">
      <mat-select id='ddlLanguage' [(ngModel)]='selectedLanguageCode' (selectionChange)="languageChanged()">
        <mat-option *ngFor='let language of languages' [value]='language.Code'>{{language.CodeDescription}}</mat-option>
      </mat-select>
    </tyl-form-field>
  </div>
  <!-- <kendo-pdf-export #pdf paperSize="Letter" [keepTogether]="'.eFormControl'" id="formToPrint" #printRef
    style="display:flex;flex-direction: column; flex:1;padding-bottom: 10px;"> -->
    <kendo-pdf-export #pdf paperSize="Letter" [keepTogether]="" id="formToPrint" #printRef [ngStyle]="{'padding-bottom':hideKendoBottomPadding ? '' : '50px'}"
      style="display:flex;flex-direction: column; flex:1;overflow:auto;">
    <student-header [pageTitle]='' style="max-height:100px;"
      *ngIf="(config.ViewMode == 'form' || config.ViewMode == 'review') && selectedForm && selectedForm.Student_ID > 0 && selectedStudent && !isBehaviorLetter"
      [studentId]="selectedForm.Student_ID" [disableYearSelect]="true" [disableNavigation]="true"
      [showYearSelector]="false" [useYear]="selectedYear" [hideAlerts]="showPrintDiv" [useStudents]="[selectedStudent]">
    </student-header>
    <div [ngClass]="(config.ViewMode == 'page' || config.ViewMode == 'customPage' || config.ViewMode == 'frma') ? 'pageBox': (config.IsMobilePreview ? 'mobileBox' : 'contentBox')" *ngIf="showContent">
      <h3 class="eFormTitle sis-app-header-label" *ngIf="!config.HideTitle">
        <span translate *ngIf="isPreview && config.ViewMode != 'form'">Preview:&nbsp;</span><span
          translate>{{config.Title | tylTranslate}}</span>
      </h3>
      <h3 class="eFormTitle sis-app-header-label" *ngIf="formName && !config.HideTitle">
        <span translate>{{formName | tylTranslate}}</span>
      </h3>
      <e-form-viewer-header [config]="config" *ngIf="config.ShowHeader"></e-form-viewer-header>
      <!-- Normal view (single page) -->
      <ng-container *ngIf="!showPrintDiv">
        <tabs *ngIf="tabNames.length > 1" [tabNames]="tabNames"
          [disabledTabs]="!isPreview && !isReview && editable ? tabNames : null"
          (tabChange)="selectedTabChanged($event)" (click)="tabsClick()"></tabs>
        <div style="display: flex;height: 40px; padding-top: 10px;" *ngIf="checkVisiblePageCount()">
          <div style="width: 50%;">
            {{selectedPage.Name}}
          </div>
          <div style="width: 50%;text-align: end;padding-right: 20px;">
            Page {{selectedPageNumber}} of {{selectedTab.Pages.length}}
          </div>
        </div>
        <form #viewerForm="ngForm" id="vForm">
          <div class="row" style="flex:1;margin-top:20px;padding-bottom:10px;" *ngIf="selectedPage">
            <e-form-viewer-column *ngFor="let column of selectedPage.Columns; let i = index" [column]="column" [masterId]="masterId" [designPageIndex]="designPageIndex"
              [editable]='editable' [disableMergeFields]='disableMergeFields' (viewInitialized)="columnInitialized(column)" [config]="config" [topLevel]="true" class="eFormColumn"
              [ngStyle]="{'width': config.IsMobilePreview ? '100%' : (column.FixedWidth ? (column.Width + 'px') : '')}" [showConditionals]="config.AlwaysShowAllConditionals"
              [ngClass]="{'fixedWidth': column.FixedWidth}">
            </e-form-viewer-column>
          </div>
        </form>
      </ng-container>
      <!-- Print View (all tabs/pages)  -->      
      <ng-container *ngIf="showPrintDiv">
        <div *ngFor="let tab of visibleTabs">
          <hr *ngIf="visibleTabs.length > 1">
          <span *ngIf="visibleTabs.length > 1">{{tab.Name ? tab.Name.toUpperCase():''}}</span>
          <div class="row" style="flex:1;margin-top:20px;overflow:auto;padding-bottom: 60px;" *ngFor="let page of tab.Pages">
            <div *ngIf="page.Visible || showAllConditionalsPrint">
              <hr *ngIf="tab.Pages.length> 1">
              <span *ngIf="tab.Pages.length> 1">{{page.Name}}</span>
              <!-- <hr> -->
              <!-- <e-form-viewer-column *ngFor="let column of page.Columns; let i = index" [column]="column" [editable]='editable' style="flex:1;" [print]='"true"' [showConditionals]='showAllConditionalsPrint'
                (viewInitialized)="columnInitialized(column)" [ngStyle]="{'width': (column.Width + 'px')}"></e-form-viewer-column> -->
              <div class="row" style="flex:1;margin-top:20px;overflow:auto;" *ngIf="page">
                <e-form-viewer-column *ngFor="let column of page.Columns; let i = index" [column]="column" [config]="config"
                  [editable]='editable' class="eFormColumn" [print]='true' [showConditionals]='showAllConditionalsPrint'
                  (viewInitialized)="columnInitializedPrint(column)" [masterId]="masterId" [designPageIndex]="designPageIndex"
                  [ngStyle]="{'width': config.IsMobilePreview ? '100%' : (column.FixedWidth ? (column.Width + 'px') : '')}"
                  [ngClass]="{'fixedWidth': column.FixedWidth}">
                </e-form-viewer-column>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="(selectedForm && config.ShowSubmittedBy) || (selectedForm && showSubmittedInfo)"
      style="display: flex; justify-content: space-between;">
      <div>Submitted by {{selectedForm.SubmittedByName}}</div>
      <div>Submitted on {{selectedForm.SubmittedOn | date:'MM/dd/yy'}}</div>
    </div>   
  </kendo-pdf-export>
</mat-dialog-content>

<!-- <mat-dialog-actions>
  <div class='flex-footer-left'>
    <tyl-button image="save.png" label="Accept and Process" (clickEvent)="acceptClick()" *ngIf="isReview"></tyl-button>
    <tyl-button image="block.png" label="Reject" (clickEvent)="rejectClick()" *ngIf="isReview"></tyl-button>
    <tyl-button image="previous arrow.png" disabledImage="previous arrow disabled.png" label="Previous"
      (clickEvent)="previousClick()" [disabled]="isFP" *ngIf="showNextPreviousButtons"></tyl-button>
  </div>
  <div class="flex-footer-middle">
    <tyl-button image="notes.png" label="Notes" (clickEvent)="notesClick()" *ngIf="isReview"></tyl-button>
  </div>
  <div class='flex-footer-right'>
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button image="next arrow.png" disabledImage="next arrow disabled.png" label="Next" (clickEvent)="nextClick()"
      [disabled]="isLP" *ngIf="showNextPreviousButtons"></tyl-button>
    <tyl-button image="print.png" *ngIf="config.ShowPrintButton" label="Print" (clickEvent)="printClick()"></tyl-button>
    <tyl-button image="save.png" label="Submit" (clickEvent)="submitClick();validationTrigger.click();"
      *ngIf="!isPreview && isLP && !isReview && editable && !config.DisableSubmission"></tyl-button>
    <tyl-button image="clock.png" [iconWidth]="25" label="Save and Finish Later" (clickEvent)="saveClick()"
      *ngIf="!isPreview && !isReview && editable && !config.DisableSubmission"></tyl-button>
    <tyl-button image="cancel.png" [label]="isPreview || config.DisableSubmission ? 'Close' : 'Cancel'" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions> -->

<input style="display:none" type="submit" form="vForm" #validationTrigger>
